import React from 'react'
import PropTypes from 'prop-types'
import {
  Example,
  PurposeLabel,
  PurposeWrapper,
  StyledTextArea,
} from './component.styles'
import { ModalHeader } from 'components/ModalElements/component.styles'
import { LABEL_TEXT } from './constants'

const AddStatement = ({ errors, handleChange, modalData, values, touched }) => {
  const { header, choiceContent = [] } = modalData || {}
  const [visionContent = {}, exampleOne = {}] = choiceContent

  return (
    <PurposeWrapper>
      <ModalHeader>{header}</ModalHeader>
      <PurposeLabel>{visionContent?.questionText}</PurposeLabel>
      <StyledTextArea
        error={touched.purpose ? errors?.purpose : ''}
        label={LABEL_TEXT}
        name="purpose"
        onChange={event => handleChange(event.target.name, event.target.value)}
        value={values?.purpose}
      />
      <Example>{exampleOne.bodyCopy}</Example>
    </PurposeWrapper>
  )
}

AddStatement.propTypes = {
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleContinueButtonClick: PropTypes.func,
  modalData: PropTypes.shape({
    header: PropTypes.string,
    helpCopy: PropTypes.string,
    image: PropTypes.object,
    nextLabel: PropTypes.string,
  }),
  touched: PropTypes.object,
  values: PropTypes.object,
}

export default AddStatement
